export const CASE_FILE_URL = `${window.location.protocol}//${window.location.host}`